import React from 'react';
import ReactGA from 'react-ga';
import screen from './../../images/screen.png'
import download from './../../images/icon/ic_download.png'
import facebook from './../../images/icon/ic_facebook.png'
import instagram from './../../images/icon/ic_instagram.png'
import youtube from './../../images/icon/ic_youtube.png'
import './../../style/Mobile.css';

class Mobile extends React.Component {
    handleClick(key) {
        switch (key) {
            case 1:
                ReactGA.event({
                    category: 'MOBILE',
                    action: 'app stroe',
                });
                break;

            case 2:
                ReactGA.event({
                    category: 'MOBILE',
                    action: 'facebook',
                });
                break;

            case 3:
                ReactGA.event({
                    category: 'MOBILE',
                    action: 'instagram',
                });
                break;

            case 4:
                ReactGA.event({
                    category: 'MOBILE',
                    action: 'youtube',
                });
                break;
        }
    }

    render() {
        return (
            <div className="m-body">
                <div className="header">
                    <h1>MEONGCA</h1>
                    <p>camera APP for dogs</p>
                </div>
                <div className="image"><img src={screen} /></div>
                <div className="download-link">
                    <div className="btn-download">
                        <a target="_blank" onClick={()=>{this.handleClick(1)}} href="https://itunes.apple.com/kr/app/meongca/id1369505051?l=en&mt=8">
                            <img src={download} alt="download button"/>
                        </a>
                    </div>
                    <div className="btn-sns">
                        <a target="_blank" onClick={()=>{this.handleClick(2)}} href="//www.facebook.com/Naplab-360679287757142/">
                            <img src={facebook} alt="facebook button"/>
                        </a>
                        <a target="_blank" onClick={()=>{this.handleClick(3)}} href="https://www.instagram.com/meongcagram/">
                            <img src={instagram} alt="instagram button"/>
                        </a>
                        <a target="_blank" onClick={()=>{this.handleClick(4)}} href="https://www.youtube.com/watch?v=q-aipKmNDEk">
                            <img src={youtube} alt="youtube button"/>
                        </a>
                    </div>
                </div>
                <div className="footer">
                    <p>© NAPLAB 2018</p>
                </div>
            </div>
        )
    }
}

export default Mobile;


// WEBPACK FOOTER //
// ./src/components/mobile/Mobile.js